import './index.scss';
import { ACKNOWLEDGED, isAcknowledged } from '../taxQuestionnaireRules';

// Same agree toggle as the bank account form (yellow circle, tick when agreed). Value is "Yes" / "".
// In view-only mode the toggle is hidden and only the text is shown, like the bank account "View" page.
export default AcknowledgementCheckbox; function AcknowledgementCheckbox({ id, value, onChange, disabled, error, children }) {
    const checked = isAcknowledged(value);

    return (<div className='acknowledgement'>
        <div className='acknowledgement-agree' id={id}>
            {
                !disabled && (checked ? (
                    <svg onClick={() => onChange?.('')} role='checkbox' aria-checked='true' width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="11.3514" cy="12" rx="11.3514" ry="12" fill="#FFC81C" />
                        <path d="M17.71 8.31595C17.3462 7.91041 16.7396 7.89255 16.3554 8.27813L10.2381 14.411L7.32038 11.2441C6.95083 10.8433 6.34493 10.8345 5.96546 11.2252C5.58631 11.6156 5.57833 12.2568 5.94755 12.6576L9.5249 16.5403C9.71237 16.7439 9.96152 16.8466 10.2113 16.8466C10.4483 16.8466 10.6853 16.754 10.8709 16.5687L17.6743 9.748C18.0582 9.36305 18.0744 8.72184 17.71 8.31595Z" fill="#003448" />
                    </svg>
                ) : (
                    <svg onClick={() => onChange?.(ACKNOWLEDGED)} role='checkbox' aria-checked='false' width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="11.3514" cy="12" rx="11.3514" ry="12" fill="#FFC81C" />
                    </svg>
                ))
            }
            <p>{children}</p>
        </div>
        {
            error && <p className='acknowledgement-error'>{error}</p>
        }
    </div>);
}
